import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, FormControlLabel, FormGroup, Grid, Icon, IconButton, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Typography, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ProceedSaveLater, SubHeading } from './components';
import { Form, Formik, FormikProps, validateYupSchema, yupToFormErrors } from 'formik';
import MFSelectField from '../../lib/formik/SelectField';
import { Applicant, DataMaster, DataMasters, dataTypeMasters, FamilyMembers } from '../../redux-store/types/api-types';
import {
  ADDITIONAL_DETAILS_FAMILY_MEMBER_LIMIT,
  ADDITIONAL_KYC_DETAILS_CATEGORY,
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  branchMasters,
  businessUnitMasters,
  deemedOvdValue,
  dndValue,
  genderMasters,
  grossAnnualMasters,
  HeadOfFamily,
  occupationDetailsMasters,
  PEPsMasters,
  Relations,
  restrictedRelation,
  TataGroup,
  USER_ROLES,
} from '../../utils/constant';
import {
  allowDecimalNumbers,
  allowOnlyNumbers,
  applicationComparison,
  applyRoleBasedStatus,
  capitalize,
  currencyConversion,
  getApplicantName,
  getRelation,
  getRelatioship,
  getSubGroup,
  getSubOccupation,
  getWealthSource,
  handleTextPaste,
  isMinor,
  preventSpecialCharacters,
  removeSingleQuote,
  saveForLater,
  sendRoleBasedStatus,
} from '../../utils/utilityFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useCallback, useEffect, useRef, useState } from 'react';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory, useRouteMatch } from 'react-router';
import { familyMemberSchema, KYCDetailsSchema } from '../../utils/schema';
import { MFTextField } from '../../lib/formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
// import { DatePicker } from '../../lib/formik/DatePicker';
import { TextDatePicker } from '../onboarding/DatePickerWithTextFeild';
import { DayJsDatePicker } from '../onboarding/newDatePicker';
import { DeleteIcon2, DialogCloseIcon, EditIcon2 } from '../../assets/SvgIcons';
import MFCheckbox from '../../lib/formik/Checkbox';
import { formatShortDate, getFormattedISTDateString } from '../../utils/date';
import { Label } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { ConfirmationDialog, CountryCodesDropDown } from '../commonComponents';
import { showError } from '../../redux-store/actions/auth';
import { getDataMasters } from '../../redux-store/actions/onBoarding';
import CustomSelectField from '../../lib/formik/CustomSelectField';
import React from 'react';
import { CurrencyConversionToWords } from '../orderManagement/orderEntry/commonComponents';

type Values = {
  applicants: Partial<Applicant & { otherWealthSource?: string; otherIntroducer?: string; otherIntroducerSource?: string; }>[];
  families: FamilyMembers[];
  saveType: string;
};

const initialValues: Values = {
  applicants: [
    {
      occupationDetails: '',
      grossAnnualIncome: '',
      politicallyExposedPersonStatus: 'Not Applicable',
      ckycNo: '',
      grossAnnualIncomeDate: '',
      netWorthDate: '',
      netWorth: '',
      // webtopId: '',
      occupationType: '',
      occupation: '',
      subOccupation: '',
      otherSubOccupation: '',
      tataGroupEmployee: false,
      employer: '',
      dnd: 'No',
      branch: '',
      // registrationNumber: '',
      deemedOvd: false,
      gst: '',
      wealthSource: '',
      otherWealthSource: '',
      financialWealth: '',
      // accountCode: '',
      ucic: '',
      // subGroup: '',
      // otherSubGroup: '',
      headFamily: 'false',
      onboardingDate: '',
      introducer: '',
      otherIntroducer: '',
      introducerSource: '',
      otherIntroducerSource: '',
      introducerSubSource: '',
      otherIntroducerSubSource: '',
      // sourcingRm: '',
      effectiveDate: '',
      // servicingRm: '',
      businessUnit: '',
      lastReKycDate: '',
      nextReKycDate: '',
      category: '',
    },
  ],
  families: [],
  saveType: 'save and proceed',
};

const AddFamilyMemberPopup = ({
  open,
  onClose,
  value,
  setFieldValue,
  index,
  dataMasters,
  dataMasterLoading
}: {
  open: boolean;
  onClose: () => void;
  value: any;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  index: number;
  dataMasters: DataMaster;
  dataMasterLoading: boolean;
}): JSX.Element => {
  if (!open) return <></>;
  let currentFamily = {} as FamilyMembers;
  if (index !== -1) {
    currentFamily = value.filter((family: FamilyMembers) => family.sn === index)[0];
  }

  const initialFamilyMember = {
    name: '',
    gender: '',
    dob: '',
    relationship: '',
    otherRelationship: '',
    taxId: '',
    guradianTaxId: '',
    isActive: true,
    mobile: '',
    countryNameAndCode: 'India: +91',
    countryCode: '+91',
    sn: Date.now(),
  }

  const {
    GENDER = [],
    RELATIONSHIP = [],
  } = dataMasters || {};

  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  useEffect(() => {
    const mobileElement = document.getElementsByName('countryNameAndCode');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '15px',
          backgroundColor: 'background.default',
          maxWidth: '877px',
          padding: '25px',
          m: 0,
        }
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: { xs: 0, sm: '38px' } }}>
          <Typography variant="h2" sx={{ fontWeight: 600 }}>
            Add Family Member
          </Typography>
          <IconButton onClick={onClose}>
            <DialogCloseIcon />
          </IconButton>
        </Box>

        <Formik
          initialValues={index !== -1 ? currentFamily : initialFamilyMember}
          validationSchema={familyMemberSchema}
          onSubmit={(values, actions) => {
            const path = `families`;
            const currentDetails = value || [];
            if (index !== -1) {
              const updatedDetails = currentDetails?.map((detail: any, i: number) => {
                if (detail.sn === index) {
                  return values;
                }
                return detail;
              });
              setFieldValue(path, updatedDetails);
            } else {
              setFieldValue(path, [...currentDetails, values]);
            }
            actions.resetForm();
            onClose();
          }}
        >
          {({ values }) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <MFTextField name="name" label="Full Name*" placeholder="Full Name*" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name="gender"
                    label="Gender*"
                    items={GENDER?.map((val: dataTypeMasters) => ({ key: val?.description, value: val?.description }))}
                    disabled={dataMasterLoading}
                    loading={dataMasterLoading}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextDatePicker
                    label={'Date of Birth (DOB)*'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'Enter Date of Birth'}
                    name={`dob`}
                    minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name="otherRelationship"
                    label="Relationship*"
                    // items={Relations.map(relation => {
                    //   return { key: relation, value: relation }
                    // })}
                    items={RELATIONSHIP?.filter((val: dataTypeMasters) => {
                      const familyDetails = value;
                      const selectedRelations = familyDetails
                        .filter(
                          (family: any, ind: number) =>
                            family.sn !== index &&
                            family.otherRelationship &&
                            family.isActive &&
                            restrictedRelation.includes(`${family.otherRelationship ?? ''}`.toLowerCase())
                        )
                        ?.map((family: any) => `${family.otherRelationship ?? ''}`.toLowerCase());
                      return !selectedRelations.includes(`${val?.description ?? ''}`.toLowerCase());
                    })?.map((val: dataTypeMasters) => ({
                      key: val?.description,
                      value: val?.description,
                    }))
                    }
                    disabled={dataMasterLoading}
                    loading={dataMasterLoading}
                  />
                </Grid>
                {
                  values?.otherRelationship?.toLowerCase() === 'others' && (
                    <Grid item xs={12} sm={6}>
                      <MFTextField
                        name="relationship"
                        label="Please Specify Relationship*"
                        placeholder="Please Specify Relationship*" />
                    </Grid>
                  )
                }
                <Grid item xs={12} sm={6}>
                  <MFTextField name="taxId" label={`Tax ID ${isMinor(values?.dob ?? '') ? '' : '*'}`} placeholder="Tax ID" />
                </Grid>
                {
                  isMinor(values?.dob ?? '') && (
                    <Grid item xs={12} sm={6}>
                      <MFTextField name="guardianTaxId" label="Guardian Tax ID*" placeholder="Tax ID" />
                    </Grid>
                  )
                }
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name="mobile"
                    label="Mobile Number*"
                    placeholder="Mobile Number*"
                    onKeyDown={(e) => {
                      preventSpecialCharacters(e);
                    }}
                    startAdornment={
                      <CountryCodesDropDown
                        ElementWidth={mobileElementWidth && mobileElementWidth}
                        name={`countryNameAndCode`}
                        value={values.countryNameAndCode}
                      />
                    }
                  />
                </Grid>
              </Grid>

              <DialogActions sx={{ pt: 4 }}>
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  sx={{
                    fontWeight: 500,
                    fontSize: 14,
                    p: 1,
                    backgroundColor: 'primary.main'
                  }}
                >
                  Add
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

const KYCDetails = ({
  applicant,
  index,
  value,
  setFieldValue,
  dataMasters,
  dependentDataMasters,
  loadingObject,
  handleValueFetch,
  handleSubOccupationFinder,
  dataMasterLoading
}: {
  applicant: string;
  index: number;
  value: any;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  dataMasters: DataMaster;
  dependentDataMasters: { [key: string]: any[] };
  loadingObject: { [key: string]: boolean };
  handleValueFetch: (params: { category: string; parent: string; field: string }) => Promise<void>;
  handleSubOccupationFinder: (value: string) => void;
  dataMasterLoading: boolean
}): JSX.Element => {
  const { path: currentPath } = useRouteMatch();
  const theme = useTheme();

  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { locale, currencyCode, currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);
  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application");

  const {
    OCCUPATION = [],
    PEP_STATUS = [],
    DND_STATUS = [],
    INCOME_SLAB = [],
    INTRODUCER = [],
    CATEGORY = [],
    BRANCH = [],
    SOURCE_OF_WEALTH = [],
    BUSINESS_UNIT = [],
  } = dataMasters || {};

  const {
    SUB_OCCUPATION = [],
    INTRODUCER_SOURCE = [],
    INTRODUCER_SUB_SOURCE = [],
  } = dependentDataMasters || {};

  const refactoredNetWorth = `${value?.netWorth ?? ""}`?.replaceAll(',', '');
  const refactoredFinancialWealth = `${value?.financialWealth ?? ""}`?.replaceAll(',', '');

  return (
    <>
      <Grid item xs={12}>
        {/* <SubHeading>Additional KYC Details of {applicant} Applicant</SubHeading> */}
        <SubHeading>Additional Details of {applicant} Applicant</SubHeading>
      </Grid>
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.grossAnnualIncome`}
          label={`Gross Annual Income (in ${currencyCode})* `}
          items={INCOME_SLAB?.map((obj: dataTypeMasters) => ({
            key: obj?.description,
            value: obj?.description
          }))}
          sx={{
            "&.MuiOutlinedInput-root": {
              "& fieldset>legend": {
                fontSize: "0.78em",
              }
            },
            '& .MuiSelect-icon': {
              width: '1em !important',
              height: '1em !important',
            },
          }}
          disabled={dataMasterLoading}
          loading={dataMasterLoading}
        />
      </Grid>
      {/* <Grid item xs={12} lg={6}>
        <TextDatePicker
          label={'Gross Annual Income as on Date*'}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'Enter Net worth as on Date'}
          name={`applicants.${index}.grossAnnualIncomeDate`}
        />
      </Grid> */}
      <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.netWorth`}
          label={`Net Worth (in ${currencyCode})`}
          placeholder={`Enter Net Worth (in ${currencyCode})*`}
          trimOnBlur={false}
          // onKeyDown={(e) => {
          //   if (['+', 'e', 'E', " "].includes(e.key)) {
          //     e.preventDefault();
          //   }
          // }}
          startAdornment={value.netWorth ? (
            <Typography
              variant='body_500'
              sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
            >
              {String.fromCharCode(parseInt(currencySymbol, 16))}
            </Typography>
          ) : undefined}
          sx={{
            '&.MuiOutlinedInput-root': {
              '.MuiInputBase-input': {
                paddingLeft: value.netWorth ? "0px" : "15px"
              },
              "& fieldset>legend": {
                fontSize: "0.78em",
              },
            },
          }}
          onKeyDown={allowDecimalNumbers}
          formatCurrency
          formatCurrencyLocaleOptions={{
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }}
          onPaste={(event: React.ClipboardEvent<HTMLInputElement>) => handleTextPaste(event, `applicants.${index}.netWorth`)}
        />
        <CurrencyConversionToWords value={refactoredNetWorth} />
        {/* {value.netWorth && (
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: 14,
            }}>
            {currencyConversion(locale, Number(value.netWorth))}
          </Typography>
        )} */}
      </Grid>
      {/* <Grid item xs={12} lg={6}>
        <TextDatePicker
          label={'Net Worth as on Date'}
          inputLabelStyles={{
            transform: 'unset',
            fontSize: 14,
            fontWeight: 500,
            color: 'rgba(0,0,0,0.7)',
          }}
          placeholder={'Enter Net worth as on'}
          name={`applicants.${index}.netWorthDate`}
        />
      </Grid> */}
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.politicallyExposedPersonStatus`}
          label="Politically Exposed Person (PEP) Status*"
          items={PEP_STATUS?.map((pep: dataTypeMasters) => ({ key: pep?.description, value: pep?.description }))}
          sx={{
            "&.MuiOutlinedInput-root": {
              "& fieldset>legend": {
                fontSize: "0.79em",
              },
              '& .MuiSelect-icon': {
                width: '1em !important',
                height: '1em !important',
              },
            }
          }}
          disabled={dataMasterLoading}
          loading={dataMasterLoading}
        />
      </Grid>

      {[USER_ROLES.INVESTOR].includes(role) && <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.ckycNo`}
          label="CKYC Number"
          placeholder={'CKYC number'}
          type="string"
          // onKeyDown={(e) => {
          //   allowOnlyNumbers(e);
          //   if (['.'].includes(e.key)) {
          //     e.preventDefault();
          //   }
          // }}
          trimOnBlur={false}
          disabled={true}
        // disabled={isDiyInvestorOnboarding ?
        //   false :
        //   [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
        // }
        />
      </Grid>}

      {/* <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.webtopId`}
          label="Webtop Number *"
          placeholder={'Webtop Number'}
          trimOnBlur={false}
          disabled={true}
        />
      </Grid> */}
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.occupation`}
          label="Occupation*"
          items={OCCUPATION?.map((occupation: dataTypeMasters) => ({
            key: occupation?.description,
            value: occupation?.identifier
          }))}
          onChange={(e: any) => {
            const val = e.target.value;
            if (val) {
              setFieldValue(`applicants.${index}.occupation`, val);
              setFieldValue(`applicants.${index}.otherSubOccupation`, "");
              handleSubOccupationFinder(val);
            }
          }}
          disabled={dataMasterLoading}
          loading={dataMasterLoading}
        />
      </Grid>
      {/* {value.occupation && (<Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.subOccupation`}
          label="Sub occupation *"
          items={SUB_OCCUPATION?.map((val: any) => ({
            key: val?.refDisplayValue,
            value: val?.refDataValue,
          }))}
          disabled={loadingObject.subOccupation || dataMasterLoading ? true : false}
          loading={loadingObject.subOccupation || dataMasterLoading ? true : false}
        />
      </Grid>)} */}
      {(['occupation-others', 'others'].includes(`${value?.occupation ?? ''}`.toLowerCase())) &&
        (<Grid item xs={12} lg={6}>
          <MFTextField
            name={`applicants.${index}.otherSubOccupation`}
            label="Specify Occupation"
            placeholder={'Specify Occupation*'}
            type="string"
          />
        </Grid>
        )}
      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.tataGroupEmployee`}
          label="ABCL Group Employee"
          items={Object.keys(TataGroup)?.map((val) => ({
            key: TataGroup[val],
            value: val,
          }))}
          onChange={(e) => {
            const val = e.target.value;
            setFieldValue(`applicants.${index}.tataGroupEmployee`, val);
            setFieldValue(`applicants.${index}.employer`, '');
          }}
        />
      </Grid>

      {`${value.tataGroupEmployee}` === "true" && <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.employer`}
          label="Name of employer*"
          placeholder={'Name of employer'}
          type="string"
        />
      </Grid>}

      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.dnd`}
          label="DND Status *"
          items={DND_STATUS?.map((val: dataTypeMasters) => ({
            key: val?.description,
            value: val?.description,
          }))}
          disabled={dataMasterLoading}
          loading={dataMasterLoading}
        />
      </Grid>

      {/* <Grid item xs={12} lg={6}> */}
        {/* <MFTextField
          name={`applicants.${index}.branch`}
          label="Branch"
          placeholder={'Branch'}
          type="string"
        /> */}
        {/* <MFSelectField
          name={`applicants.${index}.branch`}
          label="Branch"
          items={BRANCH?.map((branch: dataTypeMasters) => ({
            key: branch?.description,
            value: branch?.description,
          }))}
          // disabled={dataMasterLoading}
          disabled={true}
          loading={dataMasterLoading}
        /> */}
      {/* </Grid> */}

      {/* <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.registrationNumber`}
          label="Registration Number"
          placeholder={'Registration Number'}
          type="number"
        />
      </Grid> */}

      {USER_ROLES.RM === role && (
        <Grid item xs={12} lg={6}>
          <MFSelectField
            name={`applicants.${index}.deemedOvd`}
            label="Deemed OVD"
            items={Object.keys(deemedOvdValue)?.map((value) => ({
              key: deemedOvdValue[value],
              value: value,
            }))}
            disabled={value.kycMethod !== 'osv'}
          />
        </Grid>
      )}
      {/* <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.gst`}
          label="GST No"
          placeholder={'GST No.'}
        />
      </Grid> */}

      <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.wealthSource`}
          label="Source of Wealth*"
          items={SOURCE_OF_WEALTH?.map((val: dataTypeMasters) => ({
            key: val?.description,
            value: val?.description,
          }))}
          disabled={dataMasterLoading}
          loading={dataMasterLoading}
        />
      </Grid>

      {/* {
        (value.wealthSource).toLowerCase() === "others" &&
        (<Grid item xs={12} lg={6}>
          <MFTextField
            name={`applicants.${index}.otherWealthSource`}
            label="Specify Source of Wealth*"
            placeholder={'Source of Wealth*'}
            type="string"
          />
        </Grid>)
      } */}

      {/* <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.financialWealth`}
          label="Estimated Financial Wealth"
          placeholder={'Estimated Financial Wealth*'}
          type="string"
          startAdornment={value.financialWealth ? (
            <Typography
              variant='body_500'
              sx={(theme: Theme) => ({ color: theme.palette.text.primary })}
            >
              {String.fromCharCode(parseInt(currencySymbol, 16))}
            </Typography>
          ) : undefined}
          sx={{
            '&.MuiOutlinedInput-root': {
              '.MuiInputBase-input': {
                paddingLeft: value.netWorth ? "0px" : "15px"
              },
              "& fieldset>legend": {
                fontSize: "0.78em",
              }
            }
          }}
          onKeyDown={allowDecimalNumbers}
          formatCurrency
          formatCurrencyLocaleOptions={{
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
          }}
          onPaste={(event: React.ClipboardEvent<HTMLInputElement>) => handleTextPaste(event, `applicants.${index}.financialWealth`)}

        />
        <CurrencyConversionToWords value={refactoredFinancialWealth} /> */}
      {/* {value.financialWealth && (
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: 14,
            }}>
            {currencyConversion(locale, Number(value.financialWealth))}
          </Typography>
        )} */}
      {/* </Grid> */}

      {/* <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.accountCode`}
          label="Account Code (L4 No.)"
          placeholder={'Account Code (L4 No.)'}
          type="string"
        // onKeyDown={(e) => preventSpecialCharacters(e)}
        />
      </Grid> */}

      {/* <Grid item xs={12} lg={6}>
        <MFTextField
          name={`applicants.${index}.ucic`}
          label="UCIC Number"
          placeholder={'UCIC Number'}
          type="string"
        // disabled={true}
        />
      </Grid> */}

      {/* <Grid item xs={12} lg={6}> */}
      {/* <MFSelectField
          name={`applicants.${index}.subGroup`}
          label="Family / Sub Group"
          items={FAMILY_SUB_GROUP.map((occupation) => ({
            key: occupation,
            value: occupation,
          }))}
        /> */}
      {/* <MFTextField
          name={`applicants.${index}.subGroup`}
          label="Family / Sub Group"
          placeholder={'Family / Sub Group'}
          type="string"
        />
      </Grid> */}

      {/* {
        (value.subGroup).toLowerCase() === "others" &&
        (<Grid item xs={12} lg={6}>
          <MFTextField
            name={`applicants.${index}.otherSubGroup`}
            label="Specify Family / Sub Group*"
            placeholder={'Family / Sub Group*'}
            type="string"
          />
        </Grid>)
      } */}
      {/* <Grid item xs={12} lg={6}>
        <MFSelectField
          name={`applicants.${index}.headFamily`}
          label="Head of Family"
          items={Object.keys(HeadOfFamily)?.map((item) => ({
            key: HeadOfFamily[item],
            value: item,
          }))}
        />
      </Grid> */}
      <Grid item xs={12} lg={6}>
        <TextDatePicker
          name={`applicants.${index}.onboardingDate`}
          label='Onboarding Date'
          placeholder={'Onboarding Date'}
          disabled={true}
        />
      </Grid>
      {/* {USER_ROLES.RM === role && (
        <>
          <Grid item xs={12} lg={6}>
            <MFSelectField
              name={`applicants.${index}.introducer`}
              label="Introducer*"
              items={INTRODUCER?.map((val: dataTypeMasters) => ({
                key: val?.description,
                value: val?.identifier,
              }))}
              onChange={(event: any) => {
                const val = event.target.value;
                if (val) {
                  setFieldValue(`applicants.${index}.introducer`, val);
                  setFieldValue(`applicants.${index}.introducerSource`, '');
                  setFieldValue(`applicants.${index}.introducerSubSource`, '');
                  handleValueFetch({ category: 'INTRODUCER_SOURCE', parent: val, field: 'introducerSource' })
                }
              }}
              disabled={dataMasterLoading}
              loading={dataMasterLoading}
            />
          </Grid>
          {
            `${value?.introducer ?? ''}`.toLowerCase() === "others" &&
            (<Grid item xs={12} lg={6}>
              <MFTextField
                name={`applicants.${index}.introducerSource`}
                label="Please mention Source*"
                placeholder={'Please mention Source*'}
                type="string"
              />
            </Grid>)
          }
        </>
      )} */}
      {/* {USER_ROLES.RM === role && value?.introducer && `${value?.introducer ?? ''}`.toLowerCase() !== "others" &&
        <>
          <Grid item xs={12} lg={6}>
            {INTRODUCER_SOURCE?.length !== 0 && (
              <MFSelectField
                name={`applicants.${index}.introducerSource`}
                label="Source*"
                items={INTRODUCER_SOURCE?.map((val: any) => ({
                  key: val?.refDisplayValue,
                  value: val?.refDataValue,
                }))}
                onChange={(event: any) => {
                  const val = event.target.value;
                  if (val) {
                    setFieldValue(`applicants.${index}.introducerSource`, val);
                    setFieldValue(`applicants.${index}.introducerSubSource`, '');
                    handleValueFetch({ category: 'INTRODUCER_SUB_SOURCE', parent: val, field: 'introducerSubSource' })
                  }
                }}
                disabled={loadingObject.introducerSource ? true : false}
                loading={loadingObject.introducerSource ? true : false}
              />
            )}
          </Grid>
          {
            (`${value?.introducerSource ?? ''}`.toLowerCase() === "others") &&
            (<Grid item xs={12} lg={6}>
              <MFTextField
                name={`applicants.${index}.introducerSubSource`}
                label="Please mention Sub Source*"
                placeholder={'Please mention Sub Source*'}
                type="string"
              />
            </Grid>)
          }
          {
            (INTRODUCER_SUB_SOURCE?.length === 0 && value?.introducer && value?.introducerSource && `${value?.introducerSource ?? ''}`.toLowerCase() !== "others") &&
            (<Grid item xs={12} lg={6}>
              <MFTextField
                name={`applicants.${index}.introducerSubSource`}
                label={`Please Specify ${capitalize(value?.introducer ?? '')}*`}
                placeholder={'Source*'}
                type="string"
              />
            </Grid>)
          }
        </>
      } */}
      {/* {USER_ROLES.RM === role && INTRODUCER_SUB_SOURCE?.length !== 0 && value?.introducer && value?.introducerSource && `${value?.introducerSource ?? ''}`.toLowerCase() !== "others" && `${value?.introducer ?? ''}`.toLowerCase() !== "others" &&
        <>
          <Grid item xs={12} lg={6}>
            {INTRODUCER_SUB_SOURCE?.length !== 0 && (
              <MFSelectField
                name={`applicants.${index}.introducerSubSource`}
                label="Sub Source*"
                items={INTRODUCER_SUB_SOURCE?.map((val: any) => ({
                  key: val?.refDisplayValue,
                  value: val?.refDataValue,
                }))}
                disabled={loadingObject.introducerSubSource ? true : false}
                loading={loadingObject.introducerSubSource ? true : false}
              />
            )}
          </Grid>
          {
            (`${value?.introducerSubSource ?? ''}`.toLowerCase() === "others" || `${value?.introducerSubSource ?? ''}`.toLowerCase() === "other_campaign") &&
            (<Grid item xs={12} lg={6}>
              <MFTextField
                name={`applicants.${index}.otherIntroducerSubSource`}
                label="Specify Sub Source*"
                placeholder={'Sub Source*'}
                type="string"
              />
            </Grid>)
          }
        </>
      } */}

      {USER_ROLES.RM === role && (
        <>
          {/* <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.sourcingRm`}
              label="Sourcing RM"
              placeholder='Sourcing RM *'
              type="string"
            />
          </Grid> */}
          <Grid item xs={12} lg={6}>
            <TextDatePicker
              name={`applicants.${index}.effectiveDate`}
              label='Effective Date'
              placeholder='Effective Date'
              disabled={true}
            />
          </Grid>
          {/* <Grid item xs={12} lg={6}>
            <MFTextField
              name={`applicants.${index}.servicingRm`}
              label="Servicing RM"
              placeholder='Servicing RM *'
              type="string"
            />
          </Grid> */}

          {/* <Grid item xs={12} lg={6}>
            <MFSelectField
              name={`applicants.${index}.businessUnit`}
              label="Business Unit"
              items={BUSINESS_UNIT?.map((val: dataTypeMasters) => ({
                key: val?.description,
                value: val?.description,
              }))}
              disabled={dataMasterLoading}
              loading={dataMasterLoading}
            />
          </Grid> */}
        </>
      )}
      <Grid item xs={12} lg={6}>
        <TextDatePicker
          name={`applicants.${index}.lastReKycDate`}
          label='Last Re-KYC Date'
          placeholder='Last Re-KYC Date'
          disabled={true}
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <TextDatePicker
          name={`applicants.${index}.nextReKycDate`}
          label='Next Re-KYC Date'
          placeholder='Next Re-KYC Date'
          disabled={true}
        />
      </Grid>
      {/* {USER_ROLES.RM === role && (
        <Grid item xs={12} lg={6}>
          <MFSelectField
            name={`applicants.${index}.category`}
            label="Category"
            items={CATEGORY?.map((val: dataTypeMasters) => ({
              key: val?.description,
              value: val?.description,
            }))}
            disabled={dataMasterLoading}
            loading={dataMasterLoading}
            isItemsTooltip
          />
        </Grid>
      )} */}

    </>
  );
};

export default function AdditionalKYCDetails(): JSX.Element {
  const [kycDetails, setkycDetails] = useState(initialValues);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { locale = "en-IN" } = useSelector((store: RootStateType) => store.currencyInfo);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { path: currentPath } = useRouteMatch();
  const theme = useTheme();
  const [openAddFamilyMemberPopup, setOpenAddFamilyMemberPopup] = useState<boolean>(false);
  const [familyToEdit, setFamilyToEdit] = useState<number>(-1);
  const isDiyInvestorOnboarding = currentPath?.includes("/investor-onboarding-application");
  const [deletePopUp, setDeletePopUp] = useState<boolean>(false);
  const [familyToDelete, setFamilyToDelete] = useState<number>(-1);
  const [dataMasters, setDataMasters] = useState<DataMaster>({} as DataMaster);
  const [dataMasterLoading, setDataMasterLoading] = useState<boolean>(false);
  const [isShowErrPopup, setShowErrPopup] = useState<boolean>(false);

  const [relationMaster, setRelationMaster] = useState<string[]>([])
  const [loadingObject, setLoadingObject] = useState<{ [key: string]: boolean }>({});
  const [dependentDataMasters, setDependentDataMasters] = useState<{ [key: string]: dataTypeMasters[] }>({});
  const [subOccupationMaster, setSubOccupationMaster] = useState<string[]>([]);
  const isLoading = false;
  const isError = false;
  const formikRef = useRef<FormikProps<Values>>(null);

  const handleSubOccupationFinder = (value: string, subOccupationMaster?: any) => {
    if (value) {
      setLoadingObject(prev => ({ ...prev, subOccupation: true }));
      const {
        SUB_OCCUPATION = subOccupationMaster
      } = dataMasters;
      if (SUB_OCCUPATION) {
        const subOccupation = SUB_OCCUPATION.filter((item: any) => `${item?.refFieldId ?? ''}`.toLowerCase() === `${value ?? ''}`.toLowerCase());
        setDependentDataMasters(prev => ({
          ...prev,
          SUB_OCCUPATION: subOccupation,
        }));
        setSubOccupationMaster(subOccupationMaster);
        setLoadingObject(prev => ({ ...prev, subOccupation: false }));
      }

    }
  }

  const handleValueFetch = async ({ category, parent, field }: { category: string, parent: string, field: string }) => {
    try {
      setLoadingObject(prev => ({ ...prev, [field]: true }));
      const res = await dispatch(getDataMasters({ category, parent })) as unknown as DataMasters;
      const data = res?.data;
      if (data) {
        setLoadingObject(prev => ({ ...prev, [field]: false }));
        setDependentDataMasters(prev => ({
          ...prev,
          [category]: data[category],
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  // useEffect(() => {
  //   (async function () {
  //     try {
  //       const res = (await dispatch(getDataMasters())) as unknown as DataMasters;
  //       setDataMasters(res?.data ?? {});
  //       setRelationMaster((res?.data?.RELATIONSHIP || []).map((item) => item?.identifier))
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  // }, []);

  useEffect(() => {
    (async function () {
      try {
        const { applicants: exisitingApplicants = [], families } = application || {};
        setDataMasterLoading(true);
        const res = (await dispatch(getDataMasters())) as unknown as DataMasters;
        const relationMaster = (res?.data?.RELATIONSHIP || [])?.map((item) => item?.description);
        if (res?.data) {
          setDataMasterLoading(false);
          setDataMasters(res?.data ?? {});
          setRelationMaster(relationMaster)
        }
        const updatedFamilies = families?.length ? families?.map((family) => ({
          ...family,
          otherRelationship: getRelatioship(relationMaster, family.relationship)
            ? family.relationship
              ? family.relationship
              : family.relationship
            : 'Others',
          relationship: getRelatioship(relationMaster, family.relationship)
            ? ''
            : family.relationship,
          sn: family.id || 0,
          countryNameAndCode: family.countryNameAndCode
            ? family.countryNameAndCode
            : 'India: +91',
          countryCode: family.countryCode ? family.countryCode : '+91',

        })) : [];

        setkycDetails({
          ...kycDetails,
          applicants: exisitingApplicants?.map((applicant) => ({
            ...applicant,
            occupationDetails: applicant.occupationDetails || '',
            grossAnnualIncome: applicant.grossAnnualIncome || '',
            // politicallyExposedPersonStatus: applicant.politicallyExposedPersonStatus
            //   ? applicant.politicallyExposedPersonStatus
            //   : isDiyInvestorOnboarding
            //     ? 'Not Applicable'
            //     : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
            //       ? ''
            //       : 'Not Applicable',
            politicallyExposedPersonStatus: applicant.politicallyExposedPersonStatus || 'Not Applicable',
            // grossAnnualIncomeDate: applicant.grossAnnualIncomeDate || `${new Date().toISOString()}`,
            // netWorthDate: applicant.netWorthDate || `${new Date().toISOString()}`,
            // netWorth: applicant.netWorth || '',
            netWorth: Number(applicant.netWorth)?.toLocaleString(locale, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }) || '',
            ckycNo: applicant.ckycNo || '',
            // webtopId: applicant.webtopId || '',
            occupation: applicant.occupation || '',
            // subOccupation: applicant.subOccupation || '',
            otherSubOccupation: applicant.otherSubOccupation || '',
            tataGroupEmployee: applicant.tataGroupEmployee || false,
            employer: applicant.employer || '',
            dnd: applicant.dnd || 'No',
            branch: applicant.branch || '',
            // registrationNumber: applicant.registrationNumber || '',
            deemedOvd: applicant.deemedOvd || false,
            gst: applicant.gst || '',
            wealthSource: applicant.wealthSource || '',
            financialWealth: Number(applicant.financialWealth)?.toLocaleString(locale, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }) || '',
            // accountCode: applicant.accountCode || '',
            ucic: applicant.ucic || '',
            // subGroup: applicant.subGroup || '',
            headFamily: applicant.headFamily || 'false',
            onboardingDate: applicant.onboardingDate || ``,
            introducer: applicant.introducer || '',
            introducerSource: applicant.introducerSource || '',
            introducerSubSource: applicant.introducerSubSource || '',
            // sourcingRm: applicant.sourcingRm || '',
            effectiveDate: (applicant.effectiveDate ? applicant.effectiveDate : applicant.onboardingDate) || ``,
            // servicingRm: applicant.servicingRm || '',
            businessUnit: applicant.businessUnit || '',
            lastReKycDate: applicant.lastReKycDate || ``,
            nextReKycDate: applicant.nextReKycDate || ``,
            category: applicant.category || '',
          })),
          families: updatedFamilies || [],
        });

        if (exisitingApplicants.length > 0) {
          exisitingApplicants[0]?.occupation &&
            handleSubOccupationFinder(exisitingApplicants[0]?.occupation, res?.data?.SUB_OCCUPATION || []);
          exisitingApplicants[0]?.introducer &&
            handleValueFetch({ category: 'INTRODUCER_SOURCE', parent: exisitingApplicants[0]?.introducer ?? '', field: 'introducerSource' });
          exisitingApplicants[0]?.introducerSource &&
            handleValueFetch({ category: 'INTRODUCER_SUB_SOURCE', parent: exisitingApplicants[0]?.introducerSource ?? '', field: 'introducerSubSource' });
        }
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleSubmit = async (values: Values) => {
    try {
      const { applicants, saveType, families } = values;
      const {
        applicants: exisitingApplicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
        families: existingFamilies = [],
      } = application || {};
      const updatedApplicants = exisitingApplicants?.map((applicant, index) => ({
        ...applicant,
        ...applicants[index],
        // subOccupation: getSubOccupation(dataMasters.SUB_OCCUPATION, applicants[index].occupation, applicants[index].subOccupation)
        //   ? applicants[index].subOccupation
        //   : applicants[index].otherSubOccupation,
        otherSubOccupation: (['occupation-others', 'others'].includes(`${applicants[index]?.occupation ?? ''}`.toLowerCase())) ? applicants[index].otherSubOccupation : '',
        netWorth: `${applicants[index].netWorth ?? ""}`?.replaceAll(',', ''),
        financialWealth: `${applicants[index].financialWealth ?? ""}`?.replaceAll(',', ''),
        wealthSource: applicants[index].wealthSource || '',
        onboardingDate: applicants[index].onboardingDate || null,
        effectiveDate: applicants[index].effectiveDate || null,
        lastReKycDate: applicants[index].lastReKycDate || null,
        nextReKycDate: applicants[index].nextReKycDate || null,
      }));
      const updatedFamilies = families.filter((family) => family?.id || family.isActive)?.map((family, index) => {
        const { otherRelationship, sn, ...rest } = family;
        return {
          ...rest,
          countryCode: rest.countryNameAndCode?.split(':')[1].trim(),
          relationship: otherRelationship?.toLowerCase() === 'others' ? family?.relationship : otherRelationship,
          dob: getFormattedISTDateString(rest.dob) ?? rest.dob,
        }
      })

      const checkApplication = applicationComparison(application, {
        ...application,
        applicants: updatedApplicants,
        families: updatedFamilies,
        currentStep: !!currentStep && currentStep > 4 ? currentStep : Number(currentStep) + 1,
      });
      const isSaveLater = saveType !== 'save and proceed';
      if (id && !checkApplication) {
        setLoading(true);
        const response = await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedApplicants,
              families: updatedFamilies,
              // status:
              //   !hasPOA &&
              //     AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
              //     status !== 'draft' &&
              //     applyRoleBasedStatus(role)
              //     ? 'sent_to_amc_approver'
              //     : status,
              status: sendRoleBasedStatus(role, status as string),
              currentStep: 5,
              //!!currentStep && currentStep > 3 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );

        if (!response) {
          setLoading(false);
          return;
        };
        !isSaveLater
          ? history.push('nominee-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('nominee-details', { id, applicant1ReferenceId })
          : history.push(saveForLater(role, id, applicant1ReferenceId, isDiyInvestorOnboarding));
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };


  return (
    <Formik
      ref={formikRef}
      initialValues={kycDetails}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, KYCDetailsSchema, true, values);
        } catch (e) {
          if (isShowErrPopup) {
            setShowErrPopup(false);
            dispatch(showError(`Please fill all required fields`));
          }
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, setFieldValue, errors }) => (
        <Grid
          container
          // rowSpacing={1}
          // columnSpacing={5}
          columnSpacing={3}
          rowSpacing={0.5}
          // sx={{
          //   width: '100%',
          //   ml: 0,
          //   '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          // }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          {values.applicants?.map((_applicant, index) => (
            <React.Fragment key={index}>
              <KYCDetails
                applicant={getApplicantName(index + 1)}
                value={_applicant}
                index={index}
                setFieldValue={setFieldValue}
                dataMasters={dataMasters}
                dependentDataMasters={dependentDataMasters}
                loadingObject={loadingObject}
                handleValueFetch={handleValueFetch}
                handleSubOccupationFinder={handleSubOccupationFinder}
                dataMasterLoading={dataMasterLoading}
              />
              {/* <Grid item xs={12} mt={'50px'}>
                <SubHeading
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '10px',
                    backgroundColor: theme.palette.warning[50],
                    color: theme.palette.warning[900],
                  }}>
                  <Typography variant='subtitle_500'>Family Members (up to 6 members Max can be captured)</Typography>
                  {values.families.filter((family) => family?.isActive).length < ADDITIONAL_DETAILS_FAMILY_MEMBER_LIMIT && <Button
                    startIcon={<AddIcon />}
                    sx={{
                      p: 0,
                      color: theme.palette.warning[900]
                    }}
                    onClick={() => setOpenAddFamilyMemberPopup(true)}
                  >
                    <Typography variant='subtitle_500' sx={{ color: theme.palette.warning[900] }}> Add</Typography>
                  </Button>}
                  <AddFamilyMemberPopup
                    open={openAddFamilyMemberPopup}
                    onClose={() => {
                      setOpenAddFamilyMemberPopup(false);
                      setFamilyToEdit(-1)
                    }}
                    value={values.families}
                    setFieldValue={setFieldValue}
                    index={familyToEdit}
                    dataMasters={dataMasters}
                    dataMasterLoading={dataMasterLoading}
                  />
                </SubHeading>

                // Table to Show Data
                <TableContainer sx={{ mt: 5 }}>
                  <Table aria-label="collapsible table" sx={{ tableLayout: 'auto' }}>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">
                          <Typography variant="subtitle_500" sx={{ width: 120 }}>NAME</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="subtitle_500" sx={{ width: 80 }}>GENDER</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="subtitle_500" sx={{ width: 100 }}>DOB</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="subtitle_500" sx={{ width: 100 }}>RELATIONSHIP</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="subtitle_500" sx={{ width: 100 }}>TAX ID</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="subtitle_500" sx={{ width: 100 }}>ACTIONS</Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {isLoading && <TableLoader row={5} column={6} />}

                      {!isLoading && !isError && values.families.filter((family) => family?.isActive)?.map((row: any, index: any) => (
                        <TableRow key={index}>
                          <TableCell align='center'>
                            <Typography variant="body_500" sx={{ width: 120 }}>{row.name || '-'}</Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="body_500" sx={{ width: 80 }}>{row.gender || '-'}</Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="body_500" sx={{ width: 100 }}>{formatShortDate(row.dob) || '-'}</Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="body_500" sx={{ width: 100 }}>{row?.otherRelationship?.toLowerCase() === 'others' ? row.relationship : row.otherRelationship || '-'}</Typography>
                          </TableCell>
                          <TableCell align="center">
                            <Typography variant="body_500" sx={{ width: 100 }}>{row.taxId || row.guardianTaxId || '-'}</Typography>
                          </TableCell>
                          <TableCell align="center" sx={{ display: 'flex', justifyContent: 'center' }}>
                            <IconButton onClick={() => {
                              const idx = values?.families?.findIndex((family) => family.sn === row.sn);
                              if (idx !== -1) {
                                setFamilyToDelete(idx);
                                setDeletePopUp(true);
                              }
                            }}
                            >
                              <DeleteIcon2 width='25px' height='25px' />
                            </IconButton>
                            <IconButton onClick={() => {
                              setFamilyToEdit(row.sn);
                              setOpenAddFamilyMemberPopup(true);
                            }}
                            >
                              <EditIcon2 width='25px' height='25px' />
                            </IconButton>
                          </TableCell>
                        </TableRow>

                      ))}

                      {!isLoading && !isError && values.families.filter((row: any) => row.isActive).length === 0 && (
                        <TableRow>
                          <TableCell colSpan={8}>
                            <Typography align="center" variant="body_500" color="text.primary">
                              No data found
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}

                      {isError && (
                        <TableRow>
                          <TableCell colSpan={8}>
                            <Typography align="center" variant="body_500" color="text.primary">
                              No data found
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

              </Grid> */}

              <ConfirmationDialog
                message={'Are you sure you want to delete this family ?'}
                open={deletePopUp}
                setOpen={() => setDeletePopUp(false)}
                onSave={() => {
                  setFieldValue(`families.${familyToDelete}.isActive`, false);
                  setFamilyToDelete(-1);
                  setDeletePopUp(false);
                }}
                onCancel={() => (setDeletePopUp(false), setFamilyToDelete(-1))}
              />
            </React.Fragment>
          ))}
          <Grid item xs={12} my={2} />
          <ProceedSaveLater
            saveLater={() => {
              setShowErrPopup(true);
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setShowErrPopup(true);
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
            saveButtonText="Continue"
            showEndIcon={false}
          />
        </Grid>
      )}
    </Formik>
  );
}

function TableLoader({ row = 5, column = 8 }: { row: number; column: number }) {
  return (
    <>
      {[...Array(row)]?.map((_, rowIndex) => (
        <TableRow
          key={rowIndex}
          sx={{
            '& > *': { borderBottom: 'unset' },
            px: 0,
            my: 1,
            transition: 'all 0.3s ease-in-out',
          }}
        >
          {[...Array(column)]?.map((_, colIndex) => (
            <TableCell
              key={colIndex}
              sx={{
                px: 2,
                py: 1,
              }}
            >
              <Skeleton
                variant="rectangular"
                height={24}
                animation="wave"
                sx={{
                  borderRadius: 1,
                  bgcolor: 'grey.200',
                }}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

